import {
    PrepareDataForWriteACounselorReview,
    WriteACounselorReviewTrackingData,
    PageTrackingData,
} from "../types";
import {pageTrackingData} from "../../../utils/utils";
import {WRITE_A_COUNSELOR_REVIEW} from "../../../types";
import {isTrackingData} from "../response";

export function prepareDataForWriteACounselorReview({
    activePage,
    isMobile,
    pageConfig,
    field,
    counselorId,
}: PrepareDataForWriteACounselorReview):
    | Omit<WriteACounselorReviewTrackingData, "referralURL" | "referralTitle">
    | Record<string, unknown> {
    const trackingData = pageTrackingData(isMobile, pageConfig, activePage, field) as
        | PageTrackingData
        | Record<string, unknown>;

    if (isTrackingData(trackingData)) {
        return {
            ...trackingData[field],
            ctaType: typeof WRITE_A_COUNSELOR_REVIEW,
            counselorId: counselorId,
        };
    } else {
        return {};
    }
}
